import React, { type FunctionComponent, useState } from 'react'
import { Dialog } from '../../../../../common/Dialog'
import { Link } from 'react-router-dom'
import { RecursiveList } from './RecursiveList'
import { readableCharityFieldMap } from '../../../../../../lib/charity'
import { readableCampaignFieldMap } from '../../../../../../lib/campaign'
import { Button } from '@tomra/design-system-react/button'

type Props = {
  data: CharityReportType
}

export const CharityPreview: FunctionComponent<Props> = ({ data }) => {
  const [charityToPreview, setCharityToPreview] = useState<CharityReportType | null>(null)

  return (
    <>
      <button
        className="link"
        onClick={() => {
          if (charityToPreview?.charity.id === data.charity.id) {
            setCharityToPreview(null)
          } else {
            setCharityToPreview(data)
          }
        }}
      >
        More
      </button>

      {charityToPreview && (
        <Dialog ariaLabel="Charity preview">
          <div className="card py-md max-w-screen-md min-w-screen-md">
            <div className="flex items-start justify-between px-lg py-sm">
              <h1 className="text-xl">Details</h1>

              <Link to={`/charities/${data.charity.id}`} target="_blank" className="link">
                Go to charity page
              </Link>
            </div>

            <div className="max-h-[50vh] grid gap-sm px-lg overflow-y-scroll">
              <RecursiveList
                prefix="charity"
                keyMap={{ charity: readableCharityFieldMap }}
                data={charityToPreview.charity}
                keysToIgnore={['updatedAt', 'updatedBy', 'administratorUserId', 'logoUrl', 'registeredState']}
              />

              {charityToPreview.campaign && (
                <RecursiveList
                  prefix="campaign"
                  keyMap={{ campaign: readableCampaignFieldMap }}
                  data={charityToPreview.campaign}
                  keysToIgnore={[
                    'updatedAt',
                    'updatedBy',
                    'logoUrl',
                    'charityId',
                    'facebookHandle',
                    'instagramHandle',
                    'linkedinHandle',
                    'snapchatHandle',
                    'tiktokHandle',
                    'youtubeHandle'
                  ]}
                />
              )}
            </div>

            <div className="flex justify-end pt-md px-lg">
              <Button onClick={() => setCharityToPreview(null)}>Close</Button>
            </div>
          </div>
        </Dialog>
      )}
    </>
  )
}
